export const categoryType = {
  MOVIE: 'movie',
  SERIE: 'serie',
}
